import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector } from "redux-form";
import {
    renderInputWithLabel
} from "../../components/form/FormComponent";
import { listActivity } from "../../actions/master-data/activity_action";
import { getListActivity, getActivityPending, getActivityError } from "../../reducers/master-data/activity_reducer";
import { p2kbList, uploadP2kb } from "../../actions/p2kb/p2kb_action";
import {
    getP2kbListPending,
    getP2kbList,
    getP2kbListError,
    getP2kbUploadPending,
    getP2kbUpload,
    getP2kbUploadError,
} from "../../reducers/p2kb/p2kb_reducer";
// import moment from 'moment';
import DetailContentLihatBerkas from "../../components/detail/DetailContentLihatBerkas";
import ModalDetailDokumenSKP from "./Modal_document_pdf";
import ModalDetailDokumen from "./Modal_document";

class ModalDetailSKP_Seminar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tempSKPData: JSON.parse(localStorage.getItem("skp_add_data_temp")),
            skp_detail: JSON.parse(localStorage.getItem("skp_detail")),
            modalDetailDokumenSKPShow: false,
            modalDetailDokumenShow: false,
            berkas_sertifikat: "",
            imgUrl: "",
            modal_title: "",
            selected_activity: null,
            selected_scale: null,
            selected_peran: null,
            selected_duration: null
        }
    }

    handleOpenDocument(imgUrl, modal_title) {
        this.setState({ imgUrl: imgUrl })
        this.setState({ modal_title: modal_title })
        if (imgUrl.split('.')[1] === "pdf") {
            this.setState({ modalDetailDokumenSKPShow: true })
        } else {
            this.setState({ modalDetailDokumenShow: true })
        }
    }

    componentDidMount() {
        this.props.listActivity({ length: 999 });
    }

    render() {
        const { show,
            onHide,
            activity_id
        } = this.props;
        return (
            <Modal
                show={show}
                onHide={onHide}
                aria-labelledby="contained-modal-title-vcenter"
            >
                <ModalDetailDokumenSKP
                    show={this.state.modalDetailDokumenSKPShow}
                    onHide={() => this.setState({ modalDetailDokumenSKPShow: false })}
                    imgUrl={this.state.imgUrl}
                    modal_title={this.state.modal_title}
                />
                <ModalDetailDokumen
                    show={this.state.modalDetailDokumenShow}
                    onHide={() => this.setState({ modalDetailDokumenShow: false })}
                    imgUrl={this.state.imgUrl}
                    modal_title={this.state.modal_title}
                />
                <Modal.Header closeButton>
                    <p style={{ fontSize: 20, fontWeight: 600 }}>Detail SKP</p>
                </Modal.Header>
                <Modal.Body>
                    <form
                        // onSubmit={handleSubmit(this.handleSubmit)}
                        style={{ width: "100%" }}
                    >
                        <Column
                            vertical="center"
                            horizontal="stretch"
                            className={css(styles.bodyModal)}
                        >
                            <>
                                <Field
                                    name="activity_date"
                                    placeholder="Masukkan Tanggal Kegiatan"
                                    label="Tanggal Kegiatan"
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    name="activity_name"
                                    placeholder="Masukkan Nama Kegiatan"
                                    label="Nama Kegiatan"
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    name="pertemuan"
                                    placeholder="Masukkan Skala Pertemuan"
                                    label="Skala Pertemuan"
                                    isClearable={false}
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    name="last_activity_skp_detail_id"
                                    placeholder="Masukkan Peran"
                                    label="Peran"
                                    isClearable={false}
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    name="values_id"
                                    placeholder="Masukkan Durasi"
                                    label="Durasi"
                                    isClearable={false}
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    name="organizer"
                                    placeholder="Masukkan Nama Penyelenggara"
                                    label="Penyelenggara"
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    name="sk_idi"
                                    placeholder="Masukkan No SKP IDI"
                                    label="No SKP IDI"
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                {activity_id === "ba0a85d1-9af2-4eb8-83ef-7029ac9363dp" && (
                                    <>
                                        <Field
                                            name="title_of_paper"
                                            placeholder="Masukkan Judul Makalah"
                                            label="Judul Makalah"
                                            disable={true}
                                            component={renderInputWithLabel}
                                        />
                                    </>
                                )}
                                <Field
                                    name="place_of_organization"
                                    placeholder="Masukkan Tempat Penyelenggaraan"
                                    label="Tempat Penyelenggaraan"
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                <Field
                                    name="city_name"
                                    placeholder="Masukkan Nama Kota"
                                    label="Kota"
                                    disable={true}
                                    component={renderInputWithLabel}
                                />
                                {activity_id !== "ba0a85d1-9af2-4eb8-83ef-7029ac9363dr" && (
                                    <>
                                        <Field
                                            name="skp_total"
                                            placeholder="Jumlah SKP"
                                            label="Jumlah SKP"
                                            disable={true}
                                            component={renderInputWithLabel}
                                        />
                                    </>
                                )}
                                {activity_id === "ba0a85d1-9af2-4eb8-83ef-7029ac9363dr" && (
                                    <>
                                        <Field
                                            name="skp_total"
                                            placeholder="Jumlah SKP 1"
                                            label="Jumlah SKP 1"
                                            disable={true}
                                            component={renderInputWithLabel}
                                        />
                                        <Field
                                            name="total_skp_eksternal"
                                            placeholder="Jumlah SKP 2 (Optional)"
                                            label="Jumlah SKP 2 (Diisi jika SKP 1 tidak sesuai sertifikat)"
                                            disable={true}
                                            component={renderInputWithLabel}
                                        />
                                    </>
                                )}
                                <span style={{ marginBottom: 20, marginTop: 5 }}>
                                    Berkas Sertifikat
                                </span>
                                {<DetailContentLihatBerkas onClick={() => this.handleOpenDocument(this.props.formValue.berkas_sertifikat, "Sertifikat")} />}
                            </>
                        </Column>
                    </form>
                </Modal.Body>
            </Modal>
        )
    }
}

const styles = StyleSheet.create({
    approveButton: {
        background: "#2CB96A 0% 0% no-repeat padding-box",
        boxShadow: "none",
    },
    rejectButton: {
        background: "#EAEBED 0% 0% no-repeat padding-box",
        marginRight: 10,
        color: "#495057",
        boxShadow: "none",
    },
    footerModal: {
        backgroundColor: "#FBFBFD",
        padding: "20px 40px",
    },
    bodyModal: {
        padding: "0px 40px 20px",
        width: "100%",
    },
})

ModalDetailSKP_Seminar = reduxForm({
    form: "ModalDetailSKP_Seminar",
    shouldError: () => true,
    enableReinitialize: true,
})(ModalDetailSKP_Seminar)

function mapStateToProps(state) {
    const { listActivity, uploadP2kb, p2kbList, selectedSKP } = state;
    const selector = formValueSelector("ModalDetailSKP_Seminar");
    const formValue = selector(state, "skp_total", "sk_idi", "pertemuan", "last_activity_skp_detail_id", "values_id", "berkas_sertifikat")
    let initialValues = {};
    let form_json = null;
    if (selectedSKP) {
        form_json = JSON.parse(selectedSKP.form_json)
        initialValues = {
            activity_date: selectedSKP.activity_date,
            activity_name: form_json.activity_name,
            pertemuan: selectedSKP.mst_activity_skp_type_detail_data.parent.name,
            last_activity_skp_detail_id: selectedSKP.mst_activity_skp_type_detail_data.name,
            values_id: selectedSKP.activity_skp_type_value_data.label,
            organizer: form_json.organizer,
            sk_idi: form_json.sk_idi,
            place_of_organization: form_json.place_of_organization,
            city_name: form_json.city_name,
            skp_total: selectedSKP.skp ? selectedSKP.skp : selectedSKP.total_skp,
            berkas_sertifikat: selectedSKP.attachments[0].filename
        }
        if (selectedSKP.mst_activity_skp_type_detail_data.activity_id === "ba0a85d1-9af2-4eb8-83ef-7029ac9363dp") {
            initialValues = {
                ...initialValues,
                title_of_paper: form_json.title_of_paper
            }
        }
        if (selectedSKP.mst_activity_skp_type_detail_data.activity_id === "ba0a85d1-9af2-4eb8-83ef-7029ac9363dr") {
            initialValues = {
                ...initialValues,
                total_skp_eksternal: form_json.total_skp_eksternal
            }
        }
    }

    return {
        p2kbList_pending: getP2kbListPending(p2kbList),
        p2kbList_data: getP2kbList(p2kbList),
        p2kbList_error: getP2kbListError(p2kbList),
        listActivity_pending: getActivityPending(listActivity),
        listActivity_data: getListActivity(listActivity),
        listActivity_error: getActivityError(listActivity),
        uploadP2kb_pending: getP2kbUploadPending(uploadP2kb),
        uploadP2kb_data: getP2kbUpload(uploadP2kb),
        uploadP2kb_error: getP2kbUploadError(uploadP2kb),
        formValue,
        initialValues
    }
}

export default connect(mapStateToProps, { listActivity, uploadP2kb, p2kbList })(withRouter(ModalDetailSKP_Seminar));